import { Casher } from '../cash.class';
import { CssWidth, Col } from './col.class';
import { AbstractTable } from '../context/abstract/table.class';
import { ColReseter } from './reseter.class';
import { SortState } from '../../../utils/sorter.class';

export class ColsCasher extends Casher<ColCash[]> {
   constructor(
      private cols: Col<object>[],
      private reseter: ColReseter<object>,
      { id, isCashable}: AbstractTable<object>
   ) {
     super({
        cellId: `Cols`,
        containerId: id,
        isActive: isCashable
     });
   }

   
   protected save() {
      return this.cols.map(col => col.toJson());
   }


   protected restore(cashedCols: ColCash[]) {
      for (const cashedCol of cashedCols) {
         const liveCol = this.cols.find($col => $col.id === cashedCol.id);
         
         if (!liveCol) { // #Change in scheme detected, erase all cash#
            this.clear();
            return null;
         }
         
         liveCol.isVisible = cashedCol.isVisible;
         liveCol.order = cashedCol.order;
         liveCol.width["width.%"] = cashedCol["width.%"];
         liveCol.width["min-width.px"] = cashedCol["min-width.px"];
         liveCol.sortable.state = cashedCol.sort;
      }

      this.reseter.organize();
   }
}

export interface ColCash extends CssWidth {
   id: string;
   isVisible: boolean;
   order: number;
   sort: SortState;
}
